export default __webpack_public_path__ + "static/media/spinner.05b05c93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Common/Spinner/spinner.svg
// module id = 882
// module chunks = 0